import React from "react";
import ModalError from "../components/common/ModalError";

const ErrorContext = React.createContext<{ onError: (err: string) => void }>({
  onError: (_: string) => {},
});

const ErrorModalProvider: React.FC = ({ children }) => {
  const [isShowModelError, setIsShowModelError] =
    React.useState<boolean>(false);
  const [textError, setTextError] = React.useState<string>("");
  const onError = (err: string) => {
    setTextError(err);
    setIsShowModelError(true);
  };
  return (
    <ErrorContext.Provider value={{ onError }}>
      <ModalError
        showErr={isShowModelError}
        setShowErr={setIsShowModelError}
        error={textError}
      />
      {children}
    </ErrorContext.Provider>
  );
};

export default ErrorModalProvider;

export const useError = () => React.useContext(ErrorContext);
